// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"5b3092c7","204":"9fe82980","332":"7cc1043d","433":"debb5186","570":"a24a0127","596":"15ee58f9","695":"fe6f3ff4","774":"9a151989","927":"32b0ada8","941":"9e6d61b8","986":"bd14394a","990":"5b7076e6"}[chunkId] + ".chunk.js";
};